import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors as Colors } from '../../themes/Colors';

import { SVGComponentProps } from '../type';

const PaymentProofStepIcon: React.FC<SVGComponentProps> = ({
  width = 20,
  height = 20,
  stroke = Colors['light-red-900'],
  fill = 'none',
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.36979 2.03328L10.7031 3.36662L13.3698 0.699951M7.03646 0.699951H3.90312C2.78302 0.699951 2.22297 0.699951 1.79514 0.917938C1.41882 1.10968 1.11286 1.41565 0.921112 1.79197C0.703125 2.21979 0.703125 2.77985 0.703125 3.89995V9.49995C0.703125 10.6201 0.703125 11.1801 0.921112 11.6079C1.11286 11.9843 1.41882 12.2902 1.79514 12.482C2.22297 12.7 2.78302 12.7 3.90312 12.7H10.0365C10.6564 12.7 10.9664 12.7 11.2208 12.6318C11.9109 12.4469 12.45 11.9078 12.635 11.2176C12.7031 10.9633 12.7031 10.6533 12.7031 10.0333M5.70313 4.36662C5.70313 5.103 5.10617 5.69995 4.36979 5.69995C3.63341 5.69995 3.03646 5.103 3.03646 4.36662C3.03646 3.63024 3.63341 3.03328 4.36979 3.03328C5.10617 3.03328 5.70313 3.63024 5.70313 4.36662ZM8.69648 6.64538L3.05722 11.772C2.74003 12.0603 2.58144 12.2045 2.56741 12.3294C2.55525 12.4377 2.59676 12.545 2.67858 12.617C2.77298 12.7 2.98731 12.7 3.41598 12.7H9.67378C10.6332 12.7 11.1129 12.7 11.4897 12.5388C11.9628 12.3364 12.3396 11.9596 12.5419 11.4866C12.7031 11.1098 12.7031 10.63 12.7031 9.6706C12.7031 9.34778 12.7031 9.18637 12.6678 9.03605C12.6235 8.84714 12.5384 8.67019 12.4186 8.51755C12.3233 8.39609 12.1973 8.29525 11.9452 8.09359L10.0803 6.60173C9.82805 6.39989 9.7019 6.29897 9.56299 6.26336C9.44055 6.23197 9.3117 6.23603 9.19148 6.27508C9.05509 6.31938 8.93555 6.42805 8.69648 6.64538Z"
        stroke="#7F1D1D"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { PaymentProofStepIcon };
